/*
 * Author: Dw
 * File Created: Thursday, 25-07-10 11:14 am
 * Last Modified: Friday, 25-07-18 03:59 pm, by Dw
 */

import type { FC } from 'react';
import { memo, useEffect, useState } from 'react';
import Image from 'next/image';
import type { SxProps, Theme } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import { useAppEntryStore } from '../../../stores/useAppEntryStore';
import { useUserInfo } from '../../../stores/useUserStore';
import { staticImgPrefix } from '../../../utils/prefix';
interface AppEntryProps {
  sx?: SxProps<Theme>;
}
const AppEntry: FC<AppEntryProps> = ({
  sx = {}
}) => {
  const {
    visible,
    hide
  } = useAppEntryStore();
  const {
    user
  } = useUserInfo();
  if (!visible) return null;
  return <a
  // hardcode
  href={`https://thedecard.com/universal_decard_GDSKDJJHH/login/signup?referral_code=${user?.userInfo?.invitationCode ?? ''}`} rel="noopener noreferrer" data-sentry-component="AppEntry" data-sentry-source-file="index.tsx">
      <Box sx={{
      p: '12px 20px',
      position: 'relative',
      background: '#242731',
      ...sx
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Box sx={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image alt="decard" height={44} src={staticImgPrefix('/logo/192x192.webp')} style={{
          borderRadius: '8px',
          objectFit: 'cover'
        }} width={44} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          <Box sx={{
          display: 'flex',
          flexDirection: 'column'
        }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Typography color="#fff" lineHeight="22px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              DeCard App
            </Typography>
            <Typography color="#9EA8B6" lineHeight="22px" variant="caption" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              Unlock more features and benefits
            </Typography>
          </Box>
        </Box>
        <Box sx={{
        position: 'absolute',
        right: '20px',
        top: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Typography color="text.secondary" sx={{
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '16px',
          color: '#A993FF'
        }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            Open App
          </Typography>
          <Icon name="Close" onClick={() => {
          hide();
        }} sx={{
          cursor: 'pointer',
          fontSize: '18px',
          color: '#707A8A'
        }} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
        </Box>
      </Box>
    </a>;
};
export default memo(AppEntry);